import React, { PropTypes } from 'react';
import _ from 'lodash';

const Item = ({ term, letter, definition, subitems = {} }) => {
  const getMarkup = () => definition;
  return (
    <li
      className="glossary-term"
      data-search={term.substring(0, 50).toLowerCase()}
      data-letter={letter}
    >
      <h3 id={term.replace(/\s+/g, '-').toLowerCase()} className="term">
        {term}
      </h3>
      <p className="definition" dangerouslySetInnerHTML={{ __html: getMarkup() }} />
      <ol>
        {_.values(subitems).map((subitem, index) => (
          <li key={index} className="subdefinition">{subitem}</li>
        ))}
      </ol>
    </li>
  );
};

Item.defaultProps = {
  subitems: {}
};

Item.propTypes = {
  term: PropTypes.string.isRequired,
  letter: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired,
  subitems: PropTypes.object
};

export default Item;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/Item/Item.js